export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
      <div className="h-10 w-10 rounded-full border-4 border-violet-200 border-t-violet-600 animate-spin" />
      <p className="mt-4 text-sm text-slate-500">Verificando sesión…</p>
    </div>
  );
}
